<template>
  <div class="notification-card__mandala-evaluation p-2">
    <User :user="mandalaEvaluation.user" />
    <div class="notification-card__mandala-evaluation__head">
      <SvgIcon
        class="notification-card__mandala-evaluation__chart-icon"
        :src="require('@/assets/images/icon_chart.svg')" />
      <span class="pl-1">{{ month }}月 月間目標</span>
    </div>
    <div
      class="notification-card__mandala-evaluation__body"
      @click="onClickActivePart">
      <p>自己評価完了</p>
    </div>
  </div>
</template>

<script>
import User from '@/components/parts/User.vue'
import { format } from 'date-fns'
import SvgIcon from '@/components/parts/SvgIcon.vue'
export default {
  components: {
    User,
    SvgIcon
  },
  props: {
    notification: {
      type: Object,
      required: true
    },
  },
  computed: {
    mandalaEvaluation() {
      return this.notification.mandalaGoalSelfEvaluation
    },
    month() {
      return format(new Date(this.mandalaEvaluation.yearMonth), 'M')
    }
  },
  methods: {
    onClickActivePart() {
      this.$emit('click-notification')
    },
  }
}
</script>

<style lang="scss" scoped>
.notification-card {
  &__mandala-evaluation {
    &__head {
      display: flex;
      align-items: center;
      font-size: $fs-m;
      font-weight: bold;

      padding-top: 20px;
      padding-bottom: 8px;
    }
    &__body {
      border: 2px solid $grey02;
      padding: 12px;
      color: $l-blue;
      font-weight: bold;
    }
    &__chart-icon {
      color: $grey05;
    }
  }
}
</style>